module.exports = "/_next/static/videos/hockey-3-fb08746a0b26a717a622b86c294b2873.webm";